<template>
  <div class="ecl-message ecl-message--info ml-3 mb-3" v-if="getMinScoring > 0">
    <svg class="ecl-icon ecl-icon--l ecl-message__icon" focusable="false" aria-hidden="true">
      <use xlink:href="@/assets/img/ecl/icons.svg#information"></use>
    </svg>
    <i18n-t keypath="message.datasets.scoreDisclaimer" tag="span">
      <app-link path="/mqa" :query="{ locale }" target="_blank">
        <i18n-t keypath="message.metadata.methodologyPage"></i18n-t>
      </app-link>
    </i18n-t>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {AppLink} from "@piveau/piveau-hub-ui-modules";
export default {
  name: "DatasetsInfoBox",
  components: { AppLink },
  computed: {
    ...mapGetters("datasets", ["getMinScoring"]),
    locale() {
      return this.$route.query.locale
    }
  }
}
</script>
